/**
 * รูปสำรองเวลาโหลดรูปจริงไม่ได้
 *
 * เดิมชี้ไปที่ไฟล์บน OSS (postpertybucket01) ซึ่งบัคเก็ตถูกลบไปแล้ว — onError จึงไปโหลด
 * รูปที่พังอีกใบ กลายเป็นไอคอนรูปแตกทุกครั้ง ตอนนี้ฝังเป็น data URI จึงไม่มีทางโหลดไม่ขึ้น
 * และไม่ต้องพึ่งเน็ต
 */
export const DEFAULT_AVATAR =
  "data:image/svg+xml;charset=utf-8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">
       <rect width="96" height="96" rx="48" fill="#E5E7EB"/>
       <circle cx="48" cy="38" r="16" fill="#9CA3AF"/>
       <path d="M16 88a32 32 0 0 1 64 0z" fill="#9CA3AF"/>
     </svg>`
  );

/** โลโก้ Postperty (ไฟล์ชุดเดียวกับที่แอปมือถือใช้ อยู่ใน public/branding/) */
export const POSTPERTY_LOGO = "/branding/postperty-logo.png";
